module.exports = __webpack_public_path__ + "img/webSite-1.0109d92a.png";